import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';

export const getUserId = () => {
  // required for local testing of huddleroom, remove before deployment
  //const storedUser = JSON.parse(localStorage.getItem('user'));
  
  const userCookie = Cookies.get('user');
  const decodedCookie = decodeURIComponent(userCookie);
  const storedUser = JSON.parse(decodedCookie);

  if (storedUser && storedUser.token) {
    const decodedToken = jwtDecode(storedUser.token);
    return decodedToken.sub; // This is your user id
  }
  return null;
};